import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[libAuthOutlet]'
})
export class AuthOutletDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
